import React from 'react';
import { Row, Col } from 'react-flexa';
import { withStyles } from '@material-ui/core/styles';
import Button from '@material-ui/core/Button';
import Divider from '@material-ui/core/Divider';
import Image from '../../components/Image';
import Typography from '../../components/Typography';
import PlayIcon from '@material-ui/icons/PlayCircleOutline';

const styles = theme => ({
  videoHeading: {
    position: 'relative',
    margin: '0 auto',
    maxWidth: 560,
    boxShadow: '0 20px 40px rgba(0,0,0,0.3)',
    borderRadius: 3,
    textAlign: 'center',
    zIndex: 1,
    padding: '1rem 0',
    top: '-30px',
    backgroundColor: theme.palette.background.paper,
  },
  videoInner: {
    position: 'relative',
    paddingBottom: '56.25%',
    paddingTop: 30,
    height: 0,
    overflow: 'hidden'
  },
  videoIframe: {
    position: 'absolute',
    top: 0,
    left: 0,
    width: '100%',
    height: '100%'
  },
  videoPlayButton: {
    position: 'absolute',
    top: '40%',
    left: '40%',
    zIndex: 1,
    width: '20%',
    maxWidth: 200
  },
  videoStillImage: {
    top: 0,
    left: 0,
    width: '100%',
  },
  videoFooter: {
    position: 'relative',
    margin: '-10% auto 0',
    maxWidth: 1200,
    width: '90%',
    padding: '2.5rem 3rem',
    boxShadow: '0 30px 45px 0 rgba(0,0,0,0.1)',
    backgroundColor: theme.palette.background.paper,
    [theme.breakpoints.down('xs')]: {
      width: '100%',
      padding: '1rem .5rem',
      marginTop: 0,
    },
  },
  divider: {
    width: 64, 
    backgroundColor: theme.palette.primary.main, 
    height: 2, 
    marginTop: '2rem'
  }
});



class TestimonialVideo extends React.Component {
  render() {
    const { classes} = this.props;
    return (
      <div id="video-outer">
        <div className={classes.videoHeading}><Typography bold={true} variant='h2'>Member Testimonials</Typography></div>
        <div className={classes.videoInner}>
          <iframe className={classes.videoIframe}
                  src="https://www.youtube.com/embed/g9LRIz5pV7o?autoplay=0&rel=0">

          </iframe>
        </div>
        <div className={classes.videoFooter}>
          <Row gutter={0}>
            <Col xs={12} sm={12} md={6} gutter={0} style={{ padding: '0 1rem' }}>
              <Typography color='primary' variant='subtitle2'>KELOWNA, BC</Typography>
              <Typography variant='h1' bold={true} style={{ margin: '10px 0' }}>Home Remodel with the Mongrains</Typography>
              <Divider className={classes.divider} />
            </Col>
            <Col xs={12} sm={12} md={6} gutter={0} style={{ padding: '0 1rem' }}>
              <Image src="/homepage/star.svg" />
              <Typography variant='body1'>
                According to their assessments, they saved tens of thousands of dollars in the building process--with an
                <em>estimated savings of $15,000 </em>&nbsp;on their kitchen cabinets alone, and another <em>$3,000</em>&nbsp;on appliances.
              </Typography>
              <Button
                component='a'
                href='https://youtu.be/g9LRIz5pV7o'
                variant='contained'
                color='primary'
                size='large'
                target='_blank'
              >
                SEE THEIR STORY&nbsp;<PlayIcon/>
              </Button>
            </Col>
          </Row>
        </div>
      </div>
    );
  }
}

export default withStyles(styles)(TestimonialVideo);
